import {Upload} from "element-ui";
import ResourceSvc from "@/services/resource.svc.js";
import store from "@/services/store.js";
import {EventBus} from "@/services/Event.js";

const svc = new ResourceSvc();

export default {
    name: "userCard",
    components: {
        [Upload.name]: Upload,
        Upload,
    },
    data() {
        return {
            isProcessing: true,
            siteUserMembershipId: 7,
            user: {
                details: {
                    createdDateString: null,
                    divisionString: null,
                    currentMembershipTypeName: null,
                    tiNumber: null,
                    fullName: null,
                    avatarSourseBase64: null,
                },
                clubs: {
                    mainClubCurrentYear: "",
                    mainClubNextYear: "",
                },
                membership: {
                    label: "",
                    isNextYearMembership: false,
                },
            },
            data: {
                avatarSourceDefault: require("../../../../../images/add-user.svg"),
                avatarSource: require("../../../../../images/add-user.svg"),
                avatarByteArray: [],
                fileName: "",
            },
        };
    },
    methods: {
        getData(id) {
            var self = this;

            if (id) {
                svc.getProfilePrimaryInfo({userId: id}).then(
                    (response) => {
                        var allData = response.body;
                        self.isProcessing = false;
                        if (!allData) {
                            self.$showError("Something went wrong!");
                            return;
                        }
                        if (!allData.isSuccess) {
                            self.$showError(allData.message);
                            return;
                        } else {
                            self.user = allData;

                            store.commit("setCurrentUserShortInfo", self.user);
                            EventBus.$emit("view-race-ragistration-load-user");
                            EventBus.$emit("user-load-junior-one-day-membership-menu");
                            EventBus.$emit("user-update-subscribe-news", self.user);
                            if (self.data.avatarByteArray && self.data.avatarByteArray.length > 0) {
                                const avatarSourceBase64 = self.byteArrayToBase64(
                                    self.data.avatarByteArray
                                );
                                self.data.avatarSource = URL.createObjectURL(
                                    self.b64toBlob(avatarSourceBase64)
                                );
                            } else if (allData.details.avatarSourceBase64) {
                                self.data.avatarSource = URL.createObjectURL(
                                    self.b64toBlob(
                                        allData.details.avatarSourceBase64.split(",")[1]
                                    )
                                );
                            } else {
                                self.data.avatarSource = self.data.avatarSourceDefault;
                            }
                        }
                    },
                    () => {
                        self.$showError();
                        window.location.href = "/";
                    }
                );
                return;
            }
            var preloadedUser = store.getters.getUserShortInfo;

            self.byteArrayToBase64 = function (buffer) {
                var binary = "";
                var bytes = new Uint8Array(buffer);
                var len = bytes.byteLength;
                for (var i = 0; i < len; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }
                return window.btoa(binary);
            };

            if (
                preloadedUser &&
                preloadedUser.isSuccess &&
                self.user.details.id != id
            ) {
                self.user = preloadedUser;
                if (self.data.avatarByteArray && self.data.avatarByteArray.length > 0) {
                    const avatarSourceBase64 = self.byteArrayToBase64(
                        self.data.avatarByteArray
                    );
                    self.data.avatarSource = URL.createObjectURL(
                        self.b64toBlob(avatarSourceBase64)
                    );
                } else if (preloadedUser.details.avatarSourceBase64) {
                    self.data.avatarSource = URL.createObjectURL(
                        self.b64toBlob(
                            preloadedUser.details.avatarSourceBase64.split(",")[1]
                        )
                    );
                } else {
                    self.data.avatarSource = self.data.avatarSourceDefault;
                }
                self.isProcessing = false;
                EventBus.$emit("user-update-subscribe-news", self.user);
            } else {
                setTimeout(function () {
                    self.getData(0);
                }, 0);
            }
        },
        getName(prop) {
            if (prop) {
                return prop.name;
            }
            return null;
        },
        showSuccess(message) {
            if (!message) {
                message = "Operation success!";
            }

            this.$notify({
                message: message,
                type: "success",
                timeout: 10000,
            });
        },
        loadAvatar(file, filelist, data) {
            this.data.avatarSource = file.url;
            this.data.fileName = file.name;
            if (file.size > 3145728) {
                this.$showError(
                    "Max limit of the file length of 3 mb is reached. Please upload another file."
                );
            } else {
                var reader = new FileReader();
                reader.readAsArrayBuffer(file.raw);
                reader.onloadend = function (result) {
                    var arrayBuffer = this.result;
                    data.avatarByteArray = new Uint8Array(
                        arrayBuffer,
                        0,
                        arrayBuffer.byteLength
                    );
                };
            }

            filelist.splice(filelist.length - 1);
            this.getData(this.user.details.id);
        },
        saveAvatar() {
            var self = this;
            if (self.data.avatarByteArray && self.data.avatarByteArray.length > 0) {
                var file = {
                    id: 0,
                    data: self.data.avatarByteArray,
                    name: self.data.fileName,
                    valueUrl: "",
                    fileType: 1,
                    bytes: null,
                    uploadType: 1,
                    userId: self.user.details.id,
                };

                self.data.avatarByteArray = [];
                svc.updateProfileImage(file).then(
                    (response) => {
                        if (!response.body || !response.body.isSuccess) {
                            self.$showError(response.body.message);
                        }
                        if (store.getters.getCurrentUser.id == self.user.details.id) {
                            EventBus.$emit("load-dashboard-data");
                        }
                    },
                    (response) => {
                        self.$showError(null);
                    }
                );
            }
        },
        b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || "";
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (
                var offset = 0;
                offset < byteCharacters.length;
                offset += sliceSize
            ) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        },
    },
    mounted() {
        var self = this;
        self.getData();
        EventBus.$off("user-load-dashboard-card");
        EventBus.$on("user-load-dashboard-card", (id) => {
            self.getData(id);
        });
    },
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/user-card/user-card.js